import loadable from '@loadable/component';

export const ReactDatePickerLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "DateTime" */
      'react-datepicker'
    ),
  {
    fallback: <input readOnly />,
    ssr: false,
  },
);
